import { useEffect, useCallback, useState } from "react";
import useIsMountedRef from "../../hooks/useIsMountedRef";
import { useTranslation } from "react-i18next";
import YassirLoader from "../../components/YassirLoader";
import { useDispatch, useSelector } from "react-redux";
import { loadCountries } from "../../actions/countriesActions";
import { setCountry } from '../../actions/setCountriesActions';
import { loadProfile } from "../../actions/profileActions";
import { setIsConnected } from "../../actions/userActions";
import { setIntl } from "../../actions/intlAction";

export default function Auth({ children }) {
  const { countries } = useSelector((state) => state.countries);
  const { profile, status, error } = useSelector((state) => state.profile);

  const { i18n } = useTranslation();

  const [loaded, setLoaded] = useState(false);
  const isMountedRef = useIsMountedRef();
  const dispatch = useDispatch();

  const fetchData = useCallback(async () => {
    if (isMountedRef.current) {
      if (localStorage.getItem("token")) {
        dispatch(setIsConnected(true));
        await dispatch(loadProfile());
      } else {
        dispatch(setIsConnected(false));
      }
      await dispatch(loadCountries());
      setLoaded(true);
    }
  }, [isMountedRef, dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (status === 200 && profile?.config?.INFOS)
      dispatch(setCountry(profile?.config?.INFOS));
    else if(countries) dispatch(setCountry(countries[0]));
  }, [dispatch, profile, status, countries]);

  const resolveStatus = useCallback(() => {
    if (error) {
      localStorage.clear();
      dispatch(setIsConnected(false));
      window.location.replace('/')
    }
  }, [dispatch, error]);

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('fleetLangage') || (['fr', 'ar'].includes(navigator.language.split('-')[0].toLowerCase()) && navigator.language.split('-')[0].toLowerCase()) || window.localStorage.i18nextLng)
    dispatch(setIntl(localStorage.getItem('fleetLangage') || (['fr', 'ar'].includes(navigator.language.split('-')[0].toLowerCase()) && navigator.language.split('-')[0].toLowerCase()) || window.localStorage.i18nextLng));
  }, [i18n, dispatch])


  useEffect(() => {
    resolveStatus();
  }, [resolveStatus])

  if (!loaded || !countries || !profile) {
    return <YassirLoader />;
  }

  return children;
}
